import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_AUTH_SERVICE || 'http://localhost:8000',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token y manejar FormData correctamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Si se envía FormData, eliminar Content-Type por defecto para que Axios/navegador agregue el boundary correcto
    if (config.data instanceof FormData) {
      if (config.headers) {
        delete config.headers['Content-Type'];
        if (typeof config.headers.delete === 'function') {
          config.headers.delete('Content-Type');
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
